import { Typography } from "antd";
import styled from "styled-components";

export const StyledModifiedQuery = styled(Typography)`
    font-weight: 500;
    margin-bottom: 10px;

    i {
        color: #0A74DA;
    }
`;

export const StyledQueryFileName = styled(Typography)`
    font-weight: 500;
    margin-bottom: 10px;

    i {
        color: #0A74DA;
    }
`;

export const StyledLimitationWarning = styled(Typography)`
    font-weight: 500;
    margin-bottom: 10px;

    i {
        color: #0A74DA;
    }
`;

export const StyledWorkerStepStatus = styled(Typography)`
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #595959;
`;

export const StyledCodeExplanation = styled(Typography)`
    margin-top: 10px;
`;

export const StyledAnswerContainer = styled.div`
    background-color: white;        
`;